import Paginated from "./Paginated";

export default Paginated;
